const qualificationStatusEnum = Object.freeze({
  ACTIVE: 1,
  COMPLETED: 2,
  EXPIRED: 3,
  CANCELLED: 5
})

const qualificationStatusLabels = Object.freeze({
  1: 'QualificationStatus_Active',
  2: 'QualificationStatus_Completed',
  3: 'QualificationStatus_Expired',
  4: 'QualificationStatus_Cancelled'
})

export { qualificationStatusEnum, qualificationStatusLabels }



// WEBPACK FOOTER //
// ./src/modules/notifications-log/enum/QualificationStatusEnum.js